import collect from 'collect.js'
import utils from '@/utils'

const LIST_PARAMS_KEY = 'payroll:listParams'

export const payroll = {
  namespaced: true,
  state: {
    list: {
      data: [],
      meta: {},
    },
    listLoading: false,
    detail: {},
    detailLoading: false,
    deleteLoading: false,
    classTotalHours: {},
    listParams: JSON.parse(localStorage.getItem(LIST_PARAMS_KEY)),
  },
  getters: {
    list: (state) => {
      return state.list
    },
    detail: (state) => {
      return state.detail
    },
    isListLoading: (state) => {
      return state.listLoading
    },
    isDetailLoading: (state) => {
      return state.detailLoading
    },
    isDeleteLoading: (state) => {
      return state.deleteLoading
    },
    classTotalHours: (state) => {
      return state.classTotalHours
    },
    listParams: (state) => {
      return state.listParams
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data
    },
    setDetail(state, data) {
      state.detail = data
    },
    setListLoading(state, data) {
      state.listLoading = data
    },
    setDetailLoading(state, data) {
      state.detailLoading = data
    },
    setDeleteLoading(state, data) {
      state.deleteLoading = data
    },
    setClassTotalHours(state, data) {
      const result = {}
      const grouped = collect(data).groupBy('classroom_id').all()
      for (const key in grouped) {
        const totalHours = grouped[key].reduce((total, item) => {
          const startTime = moment(item.start_time, 'HH:mm:ss')
          const endTime = moment(item.end_time, 'HH:mm:ss')
          const hours = endTime.diff(startTime, 'hours', true)
          return total + hours
        }, 0.0)
        result[key] = totalHours
      }
      for (const key in result) {
        state.classTotalHours[key] = result[key]
      }
    },
    setListParams(state, data) {
      localStorage.setItem(LIST_PARAMS_KEY, JSON.stringify(data))
    },
  },
  actions: {
    async getList({ commit, dispatch }, filters) {
      commit('setListLoading', true)
      try {
        const response = await axios.get(`/api/payrolls`, {
          params: filters,
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'payroll/getList', error },
          { root: true }
        )
      } finally {
        commit('setListLoading', false)
      }
    },
    async getDetail({ commit }, id) {
      commit('setDetailLoading', true)
      const response = await axios.get(`/api/payrolls/${id}`)
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async create({ commit }, data) {
      commit('setDetailLoading', true)
      const response = await axios.post('/api/payrolls', data)
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async update({ commit }, data) {
      commit('setDetailLoading', true)
      const response = await axios.put(`/api/payrolls/${data.id}`, data)
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async delete({ commit }, id) {
      commit('setDeleteLoading', true)
      await axios.delete(`/api/payrolls/${id}`)
      commit('setDeleteLoading', false)
    },
    async getClassTotalHours(
      { commit },
      { classroom_id, start_date, end_date }
    ) {
      const response = await axios.get(`/api/classroom-schedules`, {
        params: {
          classroom_id,
          start_date,
          end_date,
        },
        paramsSerializer: (params) => utils.toQueryString(params),
      })
      if (response.data.data) {
        commit('setClassTotalHours', response.data.data)
      }
    },
  },
}
